<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap>
      <table cellpadding="0" cellspacing="0" id="associated">
        <tr>
          <th>
            Transaction ID
          </th>
          <th>
            Type
          </th>
          <th>
            Amount
          </th>
          <th>
            Status
          </th>
          <th>
            Authorized
          </th>
          <th>
            Settled
          </th>
        </tr>
        <tr
          v-for="(row) in transaction.associatedTransactions"
          v-if="row.request_type !== 'modify' && row.authorized !== null"
          :key="row.id"
        >
          <td>
            {{ row.tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ row.request_type }}
          </td>
          <td>
            <template v-if="row.request_type === 'credit' || row.request_type === 'achcredit' || row.request_type === 'void' || row.request_type === 'achvoid'">
              ({{ money((row.total_amount - row.fee_amount) / 100) }})
            </template>
            <!--
            <template v-else-if="row.request_type === 'void' || row.request_type === 'achvoid'">
              ({{ money(row.parent_total_amount / 100) }})
            </template>
            -->
            <template v-else>
              {{ money((row.total_amount - row.fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ row.response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(row.authorized) }}
          </td>
          <td>
            {{ datetime(row.settled) }}
          </td>
        </tr>
        <tr v-if="transaction.parent_tracking_id">
          <td>
            {{ transaction.parent_tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ transaction.parent_request_type }}
          </td>
          <td>
            <template v-if="transaction.parent_request_type === 'credit' || transaction.parent_request_type === 'achcredit' || transaction.parent_request_type === 'void' || transaction.parent_request_type === 'achvoid'">
              ({{ money((transaction.parent_total_amount - transaction.parent_fee_amount) / 100) }})
            </template>
            <template v-else>
              {{ money((transaction.parent_total_amount - transaction.parent_fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ transaction.parent_response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(transaction.parent_authorized) }}
          </td>
          <td>
            {{ datetime(transaction.parent_settled) }}
          </td>
        </tr>
        <tr v-else>
          <td>
            {{ transaction.tracking_id }}
          </td>
          <td class="text-capitalize">
            {{ transaction.request_type }}
          </td>
          <td>
            <template v-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit' || transaction.request_type === 'void' || transaction.request_type === 'achvoid'">
              ({{ money((transaction.total_amount - transaction.fee_amount) / 100) }})
            </template>
            <template v-else>
              {{ money((transaction.total_amount - transaction.fee_amount) / 100) }}
            </template>
          </td>
          <td>
            {{ transaction.response_code === '000' ? 'Approved' : 'Declined' }}
          </td>
          <td>
            {{ datetime(transaction.authorized) }}
          </td>
          <td>
            {{ datetime(transaction.settled) }}
          </td>
        </tr>
      </table>
    </v-layout>
  </v-container>
</template>

<script>
import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],

  data: function () {
    return {
      enabled: false
    }
  },

  props: {
    transaction: Object
  },

  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Associated.vue